export function initVideoPlayer() {
	startVideo();
}

function startVideo() {
	$( document ).on( 'click', '.video-action-play-video', function() {
		let $video_container = $( this ).closest( '.video' );
		let $video_image = $video_container.find( '.video-image' );
		let $video_frame = $video_container.find( '.video-iframe' )
		$video_frame.attr( 'src', $video_frame.attr( 'src' ) + '?autoplay=1&mute=1' );
		$video_image.fadeOut();
	} );
}



// WEBPACK FOOTER //
// ./scripts/components/videoPlayer.ts